import { sendCreatePermanentTokenRequest } from './api/login';
import { appIdentity } from './consts/appIdentity';
import { getParsedParams } from './consts/params';
import { env } from './env';

const isExtensionUser = (): boolean => getParsedParams().APP_IDENTITY === appIdentity.chromeAdBlock;

const isAppUser = (): boolean => {
  const identityParam = getParsedParams().APP_IDENTITY;

  return Boolean(identityParam && identityParam !== appIdentity.cabinet && identityParam !== appIdentity.chromeAdBlock);
};

const resolveAppSuccessLink = (identityParam: string | null): Promise<string> =>
  sendCreatePermanentTokenRequest().then((permToken) => {
    if (identityParam === appIdentity.macOSSite) {
      return `clearvpnsite://go/a/payment_succeeded?permanent_token=${permToken}`;
    }
    if (identityParam === appIdentity.cabinet) {
      return `${env.cabinetUrl}/profile?permanent_token=${permToken}`;
    }
    if (identityParam === appIdentity.chromeAdBlock) {
      return `${env.cabinetUrl}/h/to-chrome?permanent_token=${permToken}`;
    }

    return `clearvpn://go/a/payment_succeeded?permanent_token=${permToken}`;
  });

const resolvePreiumAppUserLink = (identityParam: string | null): Promise<string> =>
  sendCreatePermanentTokenRequest().then((permToken) => {
    if (identityParam === appIdentity.macOSSite) {
      return `clearvpnsite://go/auth?permanent_token=${permToken}`;
    }
    if (identityParam === appIdentity.cabinet) {
      return `${env.cabinetUrl}/profile?permanent_token=${permToken}`;
    }

    return `clearvpn://go/auth?permanent_token=${permToken}`;
  });

export { isExtensionUser, isAppUser, resolveAppSuccessLink, resolvePreiumAppUserLink };
